import { ImageModel } from './image-model';

export class SettingsModel {
  MenuLinks: MenuLinks[] = [];
  HeaderLinksColumn1: string = '';
  HeaderLinksColumn2: string = '';
  HeaderLinksColumn3: string = '';
  FooterText: string = '';
  FallbackCategoryTitle: string = '';
  FallbackCategoryMetaDescription: string = '';
  FallbackSubCategoryTitle: string = '';
  FallbackSubCategoryMetaDescription: string = '';
  FallbackCategoryImage: string = '';
  FallbackSubCategoryImage: string = '';
  FallbackCaseImage: string = '';
  FallbackIdeaTitle: string = '';
  FallbackIdeaMetaDescription: string = '';
  FallbackCaseTitle: string = '';
  FallbackCaseMetaDescription: string = '';
  CategoryLinks: string = '';
  BookEventButtonText: string = '';
  ContactFormText: string = '';
  CookieVersion: number = 0;
  CaseDescription: string = '';
  CaseTitle: string = '';
  CaseMetaDescription: string = '';
  CaseHeader: string = '';
  CaseOtherHeader: string = '';
}

export class MenuLinks {
  Id: number = 0;
  Name: string = '';
  Url: string = '';
  Image: ImageModel = new ImageModel();
  SubCategories: MenuSubLinks[] = [];
  // Children: MenuSubLinks[];
}

class MenuSubLinks {
  Id: number = 0;
  Name: string = '';
  Url: string = '';
}
